"use client";
import React, { useState } from "react";
import Healthcare from "./Healthcare";
import Education from "./Education";
import QSR_Chains from "./QSR_Chains";
import Fitness from "./Fitness";
import Manufacturing from "./Manufacturing";
import Retail from "./Retail";
import Corporate from "./Corporate";
import Transportation from "./Transportation";

const IndustrySection = () => {
  const [selectedSection, setSelectedSection] = useState("Retail");

  const RenderCurrectSection = (currentSection) => {
    switch (currentSection) {
      case "Retail":
        return <Retail />;
      case "Education":
        return <Education />;
      case "QSR_Chains":
        return <QSR_Chains />;
      case "Fitness":
        return <Fitness />;
      case "Manufacturing":
        return <Manufacturing />;
      case "Healthcare":
        return <Healthcare />;
      case "Corporate":
        return <Corporate />;
      case "Transportation":
        return <Transportation />;

      default:
        return null;
    }
  };
  return (
    <section className="industry_bg">
      <div className="container industry_section">
        <h2 className="feature_subheading industry_heading powerfullheading">
          Major applications of powerful AI video analytics across industries
        </h2>
        <p className="feature_content industry_heading">
          Video analytics powered by AI transform the security infrastructure of
          any organization by streamlining the overall surveillance systems.
        </p>

        <div className="industry_cat_section">
          <div className="industry_cat_nav">
            <p
              className={selectedSection === "Retail" ? "active" : ""}
              onClick={() => setSelectedSection("Retail")}
            >
              Retail
            </p>
            <p
              className={selectedSection === "Manufacturing" ? "active" : ""}
              onClick={() => setSelectedSection("Manufacturing")}
            >
              Manufacturing
            </p>
            <p
              className={selectedSection === "Healthcare" ? "active" : ""}
              onClick={() => setSelectedSection("Healthcare")}
            >
              Hospitality
            </p>
            <p
              className={selectedSection === "QSR_Chains" ? "active" : ""}
              onClick={() => setSelectedSection("QSR_Chains")}
            >
              Infrastructure
            </p>
            <p
              className={selectedSection === "Fitness" ? "active" : ""}
              onClick={() => setSelectedSection("Fitness")}
            >
              Public Sector
            </p>
            <p
              className={selectedSection === "Transportation" ? "active" : ""}
              onClick={() => setSelectedSection("Transportation")}
            >
              Smart City
            </p>
            <p
              className={selectedSection === "Education" ? "active" : ""}
              onClick={() => setSelectedSection("Education")}
            >
              Education
            </p>
          </div>

          {RenderCurrectSection(selectedSection)}
        </div>
      </div>
    </section>
  );
};

export default IndustrySection;
